module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA12.18dab6d0.jpg";